import React, { useState } from "react";

const LayoutTab = ({ handleLayoutChange, selectedLayout,updatePhotoGalleryTabData,photoGalleryTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");

    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Layout</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Layout Options</span>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("testing")}>Testing<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "testing" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Testing</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Testing Options</span>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default LayoutTab;